import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import WebpageIframe from 'web_component_library/webpageIframe';

const WebpageIframeWithOrigins = ({ mobileImage = null, ...props }) => {
  // Configure allowed origins for Freedom Mobile domains
  const allowedOrigins = [
    'https://www.freedommobile.ca',
    'https://selfserve.freedommobile.ca',
  ];

  const mobileImageUrl = mobileImage?.fields?.file?.url;

  if (mobileImageUrl) {
    return (
      <>
        <Box display={['block', 'none']}>
          <img alt="" src={mobileImageUrl} width="100%" />
        </Box>
        <Box display={['none', 'block']}>
          <WebpageIframe {...props} allowedOrigins={allowedOrigins} />
        </Box>
      </>
    );
  }

  return <WebpageIframe {...props} allowedOrigins={allowedOrigins} />;
};

WebpageIframeWithOrigins.propTypes = {
  mobileImage: PropTypes.shape({
    fields: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
};

export default WebpageIframeWithOrigins;
